export default __webpack_public_path__ + "static/page-banner-5dbfa81f3520aef8b6dea839a55a38ad.png";